import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable, of } from 'rxjs';
import { ENDPOINTS } from '@app/utils/constants/endpoints.constants';
import { Feedback } from '@app/utils/interfaces/feedback.interface';

@Injectable({
  providedIn: 'root',
})
export class FeedbackService {
  private readonly feedbackUrl: string = `${ENDPOINTS.feedbacks}`;
  private readonly http = inject(HttpClient);

  public getFeedbacks(): Observable<Feedback[]> {
    return this.http.get<Feedback[]>(this.feedbackUrl).pipe(
      catchError(() => {
        return of([]);
      }),
    );
  }
}
